import { motion } from "framer-motion";
import { STORY } from "../data";

export const Story = () => {
  return (
    <section data-testid="story-section" className="bg-[#09090B] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8 space-y-12 md:space-y-20">
        {STORY.map((block, i) => (
          <div
            key={block.title}
            data-testid={`story-block-${i}`}
            className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center"
          >
            <motion.div
              initial={{ opacity: 0, x: block.reverse ? 24 : -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className={block.reverse ? "lg:order-2" : ""}
            >
              <span className="block h-1 w-12 bg-[#DC2626] mb-5" />
              <h3 className="font-anton uppercase text-white text-3xl md:text-4xl leading-tight">
                {block.title}
              </h3>
              <p className="mt-4 text-zinc-300 text-base md:text-lg leading-relaxed max-w-xl">
                {block.text}
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.97 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className={`border-2 border-white/15 overflow-hidden ${
                block.reverse ? "lg:order-1" : ""
              }`}
            >
              <img
                src={block.img}
                alt={block.title}
                className="w-full h-64 md:h-96 object-cover"
              />
            </motion.div>
          </div>
        ))}
      </div>
    </section>
  );
};
